<template>
  <svg id="icon-logout" viewBox="0 0 20 20" width="20" height="20">
    <g fill="none" fill-rule="evenodd">
      <path stroke="currentColor" d="M-477.5-12.5h554v512h-554z" />
      <g stroke="currentColor" stroke-width="2">
        <path d="M5.684 5.832a6 6 0 1 0 8.484-.148" />
        <path d="M10 4.7v3.8" stroke-linecap="square" />
      </g>
    </g>
  </svg>
</template>
